import React from "react";

const SubscriptionStatsCard = ({ icon, label, value, loading, onClick, isActive }) => {
  return (
    <div
      onClick={onClick}
      style={{
        background: isActive ? "#FFF0F4" : "#fff",
        border: `2px solid ${isActive ? "#C0335A" : "transparent"}`,
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        flex: 1,
        minWidth: "200px",
        cursor: onClick ? "pointer" : "default",
        transition: "border-color 0.15s, background 0.15s",
      }}
    >
      <div
        style={{
          width: "48px",
          height: "48px",
          borderRadius: "12px",
          background: "#FDE8EF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          color: "#C0335A",
          fontSize: "22px",
        }}
      >
        {icon}
      </div>
      <div>
        <div style={{ fontSize: "13px", color: "#6B7280", marginBottom: "4px" }}>
          {label}
        </div>
        {loading ? (
          <div
            style={{
              width: "60px",
              height: "28px",
              background: "#e0e0e0",
              borderRadius: "4px",
              animation: "pulse 1.5s infinite",
            }}
          />
        ) : (
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#111827", lineHeight: 1 }}>
            {value ?? 0}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionStatsCard;
